import { useGetSchedulingOptions } from '../filters/useGetSchedulingOptions';
import { KpiCard } from '~/shared/components/KpiCard';

export function NeedsAssignedAnalytics() {
	const { data: options } = useGetSchedulingOptions();
	return (
		<div className="grid grid-cols-1 gap-4 md:grid-cols-3">
			<KpiCard label="Needs Assigned" value={options.needsAssignedTotal} subLabel="Total Unstaffed" />
			<KpiCard label="Team With Most" value={`${options.needsAssignedTeam} (${options.needsAssignedTeamWithMost})`} />
			<KpiCard label="Discipline With Most" value={`${options.needsAssignedDiscipline} (${options.needsAssignedDisciplineWithMost})`} />
		</div>
	);
}
